import Note from '@/pages/FurtherStory/NotePage';
import SummaryPage from '@/pages/FurtherStory/SummaryPage';

export default [
    {
        path: '/notatka/:familyId/:noteId',
        component: Note,
        name: 'further-story-note',
        meta: { requiresAuth: true },
        children: []
    },
    {
        path: '/notatka/:familyId/dodaj',
        component: Note,
        name: 'add-further-story-note',
        meta: { requiresAuth: true },
        children: []
    },
    {
        path: '/podsumowanie/:familyId',
        component: SummaryPage,
        name: 'further-story-summary',
        meta: { requiresAuth: true },
        children: []
    }
];
